import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Users, UploadCloud, ClipboardList, FileDown, Trash2, LogOut, Grid2x2, Building2 } from "lucide-react";

export default function HRLayout({ children }) {
  const { user, logout, isAdmin } = useAuth();
  const navigate = useNavigate();

  const NAV = [
    { to: "/hr", label: "Werknemers", icon: Users, end: true },
    { to: "/hr/upload", label: "Documenten uploaden", icon: UploadCloud },
    { to: "/hr/reports", label: "Rapporten", icon: ClipboardList },
    { to: "/hr/export", label: "Dossier exporteren", icon: FileDown },
    ...(isAdmin ? [{ to: "/hr/trash", label: "Prullenbak", icon: Trash2 }] : []),
  ];

  return (
    <div className="min-h-screen flex bg-background">
      <aside className="w-64 shrink-0 border-r border-border bg-card flex flex-col fixed h-screen">
        <div className="px-5 py-5 border-b border-border">
          <div className="flex items-center gap-2.5">
            <div className="h-9 w-9 rounded-md bg-teal-600 flex items-center justify-center text-white">
              <Building2 className="h-5 w-5" />
            </div>
            <div className="leading-tight">
              <div className="font-heading font-semibold text-sm">HR Documenten</div>
              <div className="text-xs text-muted-foreground">Singh Express Shop BV</div>
            </div>
          </div>
        </div>

        <nav className="flex-1 overflow-y-auto py-3 px-3 space-y-0.5">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              data-testid={`hrnav-${item.to.replace(/\//g, "-")}`}
              className={({ isActive }) =>
                `flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium transition-colors duration-200 ${
                  isActive ? "bg-teal-600 text-white" : "text-muted-foreground hover:bg-accent hover:text-accent-foreground"
                }`
              }
            >
              <item.icon className="h-4 w-4" />
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="border-t border-border p-3 space-y-1">
          <Button variant="ghost" size="sm" data-testid="hr-to-hub"
                  className="w-full justify-start text-muted-foreground hover:text-foreground"
                  onClick={() => navigate("/hub")}>
            <Grid2x2 className="h-4 w-4 mr-2" /> Modules
          </Button>
          <div className="px-2 py-1">
            <div className="text-sm font-medium truncate">{user?.name}</div>
            <div className="text-xs text-muted-foreground capitalize">{user?.role}</div>
          </div>
          <Button variant="ghost" size="sm" data-testid="hr-logout"
                  className="w-full justify-start text-muted-foreground hover:text-foreground"
                  onClick={() => { logout(); navigate("/"); }}>
            <LogOut className="h-4 w-4 mr-2" /> Afmelden
          </Button>
        </div>
      </aside>

      <main className="flex-1 ml-64 min-h-screen">
        <div className="px-6 lg:px-10 py-8 max-w-[1400px]">{children}</div>
      </main>
    </div>
  );
}
